import { MediaQueries } from '@philips-emr/tws-constants';
import { ComponentAPI } from '@philips-emr/tws-core';
import { isEnumValid } from '@philips-emr/tws-utils';

class MediaQueryAPI extends ComponentAPI {
  getQuery(): MediaQueries {
    return this.state.query;
  }

  setQuery(query: MediaQueries): void {
    if (isEnumValid(MediaQueries, query)) {
      this.setState({ query });
    }
  }
}

export default MediaQueryAPI;
